import React, { useEffect, useState } from "react";
import Layout from "../components/Layout/Layout";
import { useCard } from "../context/card";
import { useAuth } from "../context/auth";
import { useNavigate } from "react-router-dom";
import DropIn from "braintree-web-drop-in-react";
import axios from "axios";
import toast from "react-hot-toast";
import "../styles/Cart.css";

const CardPage = () => {
  const [cart, setCart] = useCard();
  const [auth, setAuth] = useAuth();
  const navigate = useNavigate();
  const [clientToken, setClientToken] = useState("");
  const [instance, setInstance] = useState("");
  const [loading, setLoading] = useState(false);

  //total price

  const totalPrice = () => {
    try {
      let total = 0;
      cart?.map((item) => {
        total = total + item.price;
      });
      return total.toLocaleString("npr-NP", {
        style: "currency",
        currency: "NPR",
      });
    } catch (error) {
      console.log(error);
    }
  };
  //delete item from cart
  const removeCartItem = (pid) => {
    try {
      let myCart = [...cart];
      let index = myCart.findIndex((item) => item._id === pid);
      myCart.splice(index, 1);
      setCart(myCart);
      localStorage.setItem("cart", JSON.stringify(myCart));
    } catch (error) {
      console.log(error);
    }
  };

  //get payment gateway token
  const getToken = async () => {
    try {
      const { data } = await axios.get(`/api/v1/product/braintree/token`);
      setClientToken(data?.clientToken);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getToken();
  }, [auth?.token]);

  // const handlePayment = async () => {
  //   try {
  //     setLoading(true);
  //     const { nonce } = await instance.requestPaymentMethod();
  //     const { data } = await axios.post(`/api/v1/product/braintree/payment`);
  //     setLoading(false);
  //     localStorage.removeItem("cart");
  //     setCart([]);
  //     navigate("/dashboard/user/orders");
  //     toast.success("Payment completed successfully");
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  const handleCashOnDelivery = async () => {
    try {
      setLoading(true);
      // Place the order (backend logic) and update the UI as needed
      const { data } = await axios.post(`/api/v1/product/casOnDelivery`, {
        cart,
        paymentMethod: "CashOnDelivery",
        address: auth?.user?.address,
      });
      setLoading(false);

      if (data) {
        if (data.success) {
          localStorage.removeItem("cart");
          setCart([]);
          toast.success(data.message);
          navigate("/dashboard/user/orders");
        } else {
          toast.error(data.message);
        }
      } else {
        console.error("Unexpected response format from the server");
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Layout title={"cart-page"}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h3 className="text-center bg-light p-2">
              {`User Name : ${auth?.token && auth?.user?.name}`}
              <p className="text-center mt-4">
                {cart?.length
                  ? `You have ${cart?.length} items in your cart ${
                      auth?.token ? "" : "Please login to checkout"
                    }`
                  : "Your card is empty"}
              </p>
            </h3>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-6  p-0 m-0">
              {cart?.map((item, index) => (
                <div key={index} className="row m-3 card flex-row">
                  <div className="col-md-4 ">
                    <img
                      src={`/api/v1/product/product-photo/${item._id}`}
                      className="card-img-top"
                      alt={item.name}
                    />
                  </div>
                  <div className="col-md-8 mt-2 p-5">
                    <h5>Name:{item.name}</h5>
                    <p>Description: {item?.description?.substring(0, 30)}</p>
                    <h5>Price: Rs. {item?.price}</h5>
                    <button
                      className="btn btn-danger m-2"
                      onClick={() => removeCartItem(item._id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-md-5 text-center cart-summary">
              <h3>Cart Summary</h3>
              <p>Total || Checkout || Payment</p>
              <hr />
              <h4>Total:{totalPrice()}</h4>
              {auth?.user?.address ? (
                <>
                  <div className="mb-3 mt-5">
                    <h4 className="mt-4 mb-3">Current Address</h4>
                    <h5 className="mb-4">{auth.user.address}</h5>
                    <button
                      className="btn btn-warning mb-3"
                      onClick={() => navigate("/dashboard/user/profile")}
                    >
                      Update Address
                    </button>
                  </div>

                  <button
                    className="btn btn-success mb-2"
                    onClick={handleCashOnDelivery}
                    disabled={!auth?.user?.address}
                  >
                    Cash on delivery
                  </button>
                </>
              ) : (
                <div className="mb-3">
                  {auth?.token ? (
                    <button
                      className=" btn btn-outline-warning"
                      onClick={() => navigate("/dashboard/user/profile")}
                    >
                      Update Address
                    </button>
                  ) : (
                    <button
                      className=" btn btn-outline-warning"
                      onClick={() =>
                        navigate("/login", {
                          state: "/cart",
                        })
                      }
                    >
                      Please login to Checkout
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CardPage;
